import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate, useLocation } from 'react-router-dom';
import Login from './pages/Login';
import Dashboard from './pages/Dashboard';
import DailyReportAccess from './pages/DailyReportAccess'; // TEMPORÁRIO — ver header do arquivo
import { AuthProvider, useAuth } from './contexts/AuthContext';
import { RefreshProvider } from './contexts/RefreshContext';

function PrivateRoute({ children }) {
  const { token, loading } = useAuth();
  const location = useLocation();

  if (loading) return null; // ou um spinner se quiser

  return token ? (
    children
  ) : (
    <Navigate to="/login" replace state={{ from: location }} />
  );
}

function App() {
  return (
    <AuthProvider>
      <Router>
        <Routes>
          <Route path="/login" element={<Login />} />
          <Route path="/acesso/dailyreport" element={<DailyReportAccess />} />
          <Route
            path="*"
            element={
             <PrivateRoute>
            <RefreshProvider>
              <Dashboard />
            </RefreshProvider>
          </PrivateRoute>
            }
          />
        </Routes>
      </Router>
    </AuthProvider>
  );
}

export default App;